export const DIVISIONS_VALIDATION_RULES = {
  name: {
    isRequiredTrim: {
      value: true,
    },
  },
  divisionNumber: {
    isRequiredTrim: {
      value: true,
    },
  },
  externalDivisionNumber: {
    maxLength: {
      value: 16,
    },
  },
  provinceCode: {
    isRequiredTrim: {
      value: true
    },
  }
};


// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/divisions/divisionsValidationRules.js